export default __webpack_public_path__ + "7d44abe9f0055bb39c3fdcfbfa1608e6.png";